export enum MetricListContextMenu {
  SelectMetrics = 'SelectMetrics',
  SelectDataSource = 'SelectDataSource'
}

export enum MetricItemContextMenu {
  MetricDetails = 'MetricDetails',
  Rankings = 'Rankings'
}
